// extracted by mini-css-extract-plugin
export var wrap = "AllNews-module--wrap--2Gsex";
export var link = "AllNews-module--link--s6Vci";
export var svg = "AllNews-module--svg--2MhBj";
export var text = "AllNews-module--text--15_YC";
export var titlewrap = "AllNews-module--titlewrap--aj8cf";
export var searchinput = "AllNews-module--searchinput--1rJfj";